/**
 * All support ticket action IDs - single source of truth.
 * These IDs connect action definitions, scopes, and handlers at compile time.
 */
export const supportTicketActionIds = {
  // Table navigation
  navigateUp: "navigateUp",
  navigateDown: "navigateDown",
  openSupportTicket: "openSupportTicket",
  openActionMenu: "openActionMenu",

  // Direct support ticket actions
  close: "close",
  reopen: "reopen",
  markInProgress: "markInProgress",
  snooze: "snooze",
  archive: "archive",
  delete: "delete",
  markRead: "markRead",
  markUnread: "markUnread",
  markSpam: "markSpam",
  unmarkSpam: "unmarkSpam",

  // Submenu trigger actions
  setPriority: "setPriority",
  assign: "assign",
  assignToMe: "assignToMe",
  addTag: "addTag",

  // Priority options
  priorityUrgent: "priorityUrgent",
  priorityClear: "priorityClear",

  // Snooze options
  snooze1h: "snooze1h",
  snooze4h: "snooze4h",
  snooze24h: "snooze24h",
  snoozeCustom: "snoozeCustom",
  snoozeClear: "snoozeClear",

  // Message input actions
  sendMessage: "sendMessage",
  deleteDraft: "deleteDraft",

  // Merge action
  mergeTicket: "mergeTicket",

  // Reply mode actions
  reply: "reply",
  replyAll: "replyAll",
  forward: "forward",
  internalNote: "internalNote",

  // Meta comment actions (Facebook/Instagram)
  hideComment: "hideComment",
  unhideComment: "unhideComment",
  deleteComment: "deleteComment",
  likeComment: "likeComment",
  unlikeComment: "unlikeComment",
  updateComment: "updateComment",
} as const;

export type SupportTicketActionId =
  (typeof supportTicketActionIds)[keyof typeof supportTicketActionIds];

const supportTicketActionIdSet = new Set<string>(
  Object.values(supportTicketActionIds),
);

export function isSupportTicketActionId(
  id: string,
): id is SupportTicketActionId {
  return supportTicketActionIdSet.has(id);
}
